<script setup>
import { computed, toRefs } from 'vue';
import { useImage } from '@vueuse/core';

const props = defineProps({
  user: { required: false, type: Object },
  class: { required: false, type: String, default: '' },
});

const { user } = toRefs(props);

const userInitials = computed(() => {
  if (user.value) {
    if (user.value.first_name) {
      return user.value.first_name.charAt(0).toUpperCase();
    } else if (user.value.email) {
      return user.value.email.charAt(0).toUpperCase();
    }
  }
  return '';
});

const userImage = computed(() => {
  if (user.value && user.value.picture) {
    return user.value.picture;
  }
  return '';
});

const { error } = useImage({ src: userImage.value });
</script>
<template>
  <Avatar
    :icon="userInitials ? '' : 'icon-[mdi--user]'"
    class="no-underline dark:!bg-surface-600"
    shape="circle"
    :label="!error && userImage ? '' : userInitials"
    :image="error ? '' : userImage"
    :class="class"
    :ptOptions="{ mergeProps: true }"
    pt:image:class="object-cover"
  />
</template>
